import { useApi, useAuth } from '../../hooks';
import { useQuery } from '@tanstack/react-query';
import { LabOrder } from '../types';

export const useUserLabs = (userId: string) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchUserLabs = async () => {
    const requestObj = {
      route: `/private/dashboard/user/${userId}/labs`,
      token: userToken,
    };

    return api(requestObj);
  };

  const { data, isInitialLoading, isLoading, isError } = useQuery<
    LabOrder[],
    Error
  >(['hc-user-labs', userToken, userId], fetchUserLabs, {
    enabled: isAuthenticated && !loading && !!userToken && !!userId,
    refetchOnWindowFocus: false,
  });

  return {
    labOrders: data,
    isInitialLoading,
    isLoading,
    isError,
  };
};
